export const SupportedLanguages = [{
  "language": "English",
  "code": "en"
}, {
  "language": "Spanish",
  "code": "es"
}];
